import { PaymentRequestState } from '@mews-commander/data-access';
import { lt } from '@mews/framework';
import { Tag } from '@optimus-web/core';
import { Dash } from '@mews-commander/ui';
import { getTagVariantFromEmptyPaymentMethodStatus, paymentRequestStateToEmptyPaymentMethodStatus } from './utils';

interface Props {
    paymentRequestState: PaymentRequestState | undefined | null;
    outline?: boolean;
}

export const EmptyPaymentMethodStatusTag = ({ paymentRequestState, outline = true }: Props) => {
    const status = paymentRequestStateToEmptyPaymentMethodStatus(paymentRequestState);

    if (!status) {
        return <Dash />;
    }

    return (
        <Tag variant={getTagVariantFromEmptyPaymentMethodStatus(status)} outline={outline}>
            {lt(`PaymentPlanEmptyPaymentMethodStatus${status}`)}
        </Tag>
    );
};
